import { render, staticRenderFns } from "./BoardingPass.vue?vue&type=template&id=d8898452&"
import script from "./BoardingPass.vue?vue&type=script&lang=js&"
export * from "./BoardingPass.vue?vue&type=script&lang=js&"
import style0 from "./BoardingPass.vue?vue&type=style&index=0&id=d8898452&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports